import { MouseEvent } from "react";
import { Certification } from "../../../../types/certificate";
import { fmt, StatusBadge } from "../../../../helpers/certificate";

export default function ViewModal({ cert, onClose }: { cert: Certification | null; onClose: () => void }) {
    if (!cert) return null;
    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 500,
            background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)",
            display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
        }} onClick={onClose}>
            <div onClick={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()} style={{
                background: "#1a1917", border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 16, width: 560, maxWidth: "90vw", maxHeight: "88vh",
                overflow: "hidden", display: "flex", flexDirection: "column",
                animation: "modalIn 0.2s ease",
            }}>
                {/* Header */}
                <div style={{
                    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
                    padding: "20px 24px", borderBottom: "1px solid rgba(255,255,255,0.07)",
                }}>
                    <div style={{ flex: 1, minWidth: 0, paddingRight: 12 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                            <StatusBadge status={cert.status} expiry={cert.expiryDate} />
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 600, color: "var(--text)", lineHeight: 1.3 }}>{cert.title}</div>
                        <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 3 }}>ID: {cert.id} · Issued by {cert.issuedBy}</div>
                    </div>
                    <button onClick={onClose} style={{
                        width: 30, height: 30, borderRadius: 7, border: "1px solid var(--border)",
                        background: "transparent", color: "var(--text3)", cursor: "pointer",
                        display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0,
                    }}>×</button>
                </div>

                {/* Body */}
                <div style={{ overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 20 }}>
                    {/* Image placeholder area */}
                    <div style={{
                        width: "100%", height: 160, background: "rgba(255,255,255,0.03)",
                        border: "1px solid var(--border)", borderRadius: 10,
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        {cert.imageUrl ? (
                            <img src={cert.imageUrl} alt={cert.title} style={{ maxHeight: 140, maxWidth: "100%", objectFit: "contain", padding: 12 }} />
                        ) : (
                            <div style={{ textAlign: "center", color: "var(--text3)" }}>
                                <div style={{ fontSize: 28, marginBottom: 6, opacity: 0.4 }}>🏅</div>
                                <div style={{ fontSize: 12 }}>No certificate image uploaded</div>
                            </div>
                        )}
                    </div>

                    <div>
                        <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: 6 }}>Description</div>
                        <div style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.7 }}>{cert.description}</div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                        {[
                            { label: "Issuing Body", value: cert.issuedBy },
                            { label: "Status", value: cert.status },
                            { label: "Issue Date", value: fmt(cert.issuedDate) },
                            { label: "Expiry Date", value: fmt(cert.expiryDate) },
                            { label: "Last Updated", value: fmt(cert.updatedAt) },
                            { label: "Record ID", value: cert.id },
                        ].map((row) => (
                            <div key={row.label} style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 14px" }}>
                                <div style={{ fontSize: 11, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.7px", marginBottom: 4 }}>{row.label}</div>
                                <div style={{ fontSize: 13, color: "var(--text2)", textTransform: row.label === "Status" ? "capitalize" : "none" }}>{row.value}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
